<template>
    <div class="Com_view">
        <div class="box_logo">
            <el-image :src="require('../assets/logo/logo_2.png')"></el-image>
        </div>
        <div class="box_nav" v-if="screenWidth > 768">
            <ul :style="scrollTop > 100 ? 'color:#4A217F;' : ''">
                <li v-for="(item, index) in navList" :key="index" @click="onRouterPath(item.path)">
                    <span >{{ item.text }}</span>
                </li>
            </ul>
        </div>
        <div class="box_nav_fold" v-else>
            <van-icon @click="dialog_status = true" style="cursor: pointer;" color="#4A217F" name="wap-nav" />
            <van-popup overlay-class="box_popup" position="right" :style="{ height: '100%', width: '50%' }"
                v-model="dialog_status" >
                <ul>
                    <div class="main">
                        <span>Main Navigation</span>
                    </div>

                    <li v-for="(item, index) in navList" :key="index"
                    @click="onRouterPath(item.path)">
                        <van-icon :name="item.icon" /><span>{{ item.text }}</span>
                    </li>

                    <div class="logo">
                        <el-image :src="require('../assets/logo/logo_1.png')"></el-image>
                        <span>鸿年科技</span>
                    </div>
                </ul>
            </van-popup>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navList: [
                {
                    text: "官网首页",
                    icon: "wap-home",
                    path: "/"
                },
                {
                    text: "关于我们",
                    icon: "manager",
                    path: "/about"
                },
                {
                    text: "品牌中心",
                    icon: "shop",
                    path: "/product"
                },
                {
                    text: "合作伙伴",
                    icon: "friends",
                    path: "/partner"
                },
            ],

            screenWidth: null,
            scrollTop: null,

            dialog_status: false,// 折叠侧边栏状态
        };
    },
    created() {
    },
    methods: {
        // handleScroll() {
        //     this.scrollTop =
        //         document.documentElement.scrollTop || document.body.scrollTop;
        // },
        onRouterPath(path){
            this.dialog_status = false
            this.$router.push({
                path:path
            })
        }
    },
    beforeDestroy() {
        // window.removeEventListener("scroll", this.handleScroll);
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };
        // window.addEventListener("scroll", this.handleScroll, false);
    }
};
</script>
<style lang="less" scoped>
@media all and (max-width: 768px) {
    .Com_view {
        padding: 8px 10px !important;
        border-radius: 5px !important;

        .box_logo {
            .el-image {
                width: 100px !important;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.Com_view {
    position: sticky;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    background: white;
    justify-content: space-between;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 5px 1px;
    // background: transparent;
    // border-radius: 10px;
    box-sizing: border-box;
    padding: 10px 20px;
    transition: all .3s;

    .box_logo {
        display: flex;
        align-items: center;

        .el-image {
            width: 150px;
        }
    }

    .box_nav {
        ul {
            display: flex;
            list-style: none;
            font-size: 14px;
            color: #4e346e;


            li {
                margin: 0 5px;
                letter-spacing: 1px;
                padding: 5px 10px;
                cursor: pointer;
                transition: all .4s;
                position: relative;

                &::after {
                    position: absolute;
                    content: "";
                    width: 80%;
                    background: #4e346e;
                    height: 1px;
                    left: 10%;
                    bottom: 0;
                    transform: scaleX(0);
                    transition: .4s;
                }

                &:hover {
                    transform: scale(1.05) translateY(-2px);
                    color: #4e346e;

                    &::after {
                        transform: scaleX(1);
                    }
                }
            }
        }
    }

    .box_nav_fold {
        ul {
            background: #30373E;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 20px 0;
            box-sizing: border-box;
            position: relative;
            color: #999;
            overflow: hidden;

            li {
                margin: 5px 15px;
                padding: 10px;
                border-radius: 5px;
                font-size: 12px;
                transition: all .3s;
                cursor: pointer;

                &:hover{
                    background: rgba(255,255,255, 0.1);
                }

                .van-icon {
                    margin-right: 5px;
                }
            }

            .main{
                background: rgba(255, 255, 255, 0.486);
                padding: 10px 25px;
                font-size: 14px;
                color: #ededed;
                margin-bottom: 10px;
            }

            .logo {
                position: absolute;
                left: -10%;
                bottom: 0;
                width: 120%;
                padding: 10% 0 0 0;
                border-radius: 5000px 5000px 0 0;
                background: white;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                transition: all .3s;
                box-shadow: 0 -2px 10px 1px rgb(60, 60, 61,.5);
                &:hover{
                    padding-bottom: 10px;
                }
                span{
                    font-size: 14px;
                    color: #4e346e;
                    font-family: 楷体;
                    letter-spacing: 2px;
                    font-weight: bold;
                    margin: 5px 0 10px 0;
                }
                .el-image{
                    width: 30%;
                }
            }
        }
    }
}
</style>